module.exports = __webpack_public_path__ + "assets/933ba1672729b55ef413c33957341ea7.mp3";